// extracted by mini-css-extract-plugin
module.exports = {"skuButton":"ZBCX-fn4l+7efbBwWbvV3A==","arrow":"_5gmR8-J7NwaHYh55l3y78w=="};